import { Button } from "@rallly/ui/button";
import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react";
import type * as React from "react";

export interface DateNavigationToolbarProps {
  year: number;
  label: string;
  onPrevious: () => void;
  onNext: () => void;
  onToday: () => void;
}

const DateNavigationToolbar: React.FunctionComponent<
  DateNavigationToolbarProps
> = ({ year, label, onPrevious, onNext }) => {
  return (
    <div className="flex h-14 w-full shrink-0 items-center px-4">
      <div className="grow font-semibold tracking-tight">
        <span className="mr-2 font-normal text-muted-foreground text-sm">
          {year}
        </span>
        <span className="font-semibold">{label}</span>
      </div>
      <div className="flex items-center space-x-2">
        <div className="flex items-center gap-x-2">
          <Button type="button" onClick={onPrevious}>
            <ChevronLeftIcon className="size-4" />
          </Button>
          <Button onClick={onNext}>
            <ChevronRightIcon className="size-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DateNavigationToolbar;
